import React, {useContext} from 'react'
import {EditedContext} from '../../../../partials/Context'

function Tagline() {
  const edited = useContext(EditedContext)
  const {edited_item, input_value, setInputValue, lawyer_data, changeBtn, setEditedItem} = edited || '';
  const {tagline} = lawyer_data || ''
  return (
    <div id="tagline">
        <h3 className="title">
          Nagłówek
          {changeBtn('tagline')}
        </h3>
          {edited_item === 'tagline' ?
            <input value={input_value.tagline} onChange={(e) => setInputValue({tagline: e.target.value})} id="tagline-input" />
            :
            <p id="tagline-content">
              {tagline ? <span className="tagline-value" onClick={()=>{setEditedItem('tagline'); setInputValue({tagline: tagline})}} >{tagline}</span> :
              <span onClick={()=>{setEditedItem('tagline'); setInputValue({tagline: tagline})}} className="description">(Nagłówek przyciągający uwagę. Dobre zdanie otwierające potrafi zwiększyć liczbę kontaktów kilkukrotnie. To najważniejsze zdanie w Twoim profilu. Pierwsze, które czyta klient.<br/>
              Np. „Grozi Ci rozwód? Zadbaj o swoje prawa i spokój dzieci.”<br/>
              „Nie płacą Ci za faktury? Pomogę odzyskać należności.”<br/>
              „ZUS kwestionuje Twoją umowę? Znam te spory od podszewki.”)
</span>
              }
            </p>
          }
    </div>
  )
}

export default Tagline